// =====================================
//
//   CMS 
//   Author: Gray
//   createtime: 2016 / 11 / 07
//
// =====================================
window.InifECMobileApp.controller("CMSDesignProjectController", ['$scope', '$timeout', '$rootScope',
    function($scope, $timeout, $rootScope) {

        // --------------------------------
        // [private] 初始化
        // --------------------------------
        var init = function() {
        }

        //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================

        //==========================
        //  Methods
        //==========================


        //==========================
        //  Init
        //==========================
        init();
    }
]);